<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0" outlined>
      <DiligenceClassFilter @onFilterChanged="refresh" />
    </v-card>
    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView :content="'Tìm kiếm'" />
    </div>
    <v-card v-else class="ma-6" outlined>
      <DiligenceClassReportTable ref="diligence-data-table" :filters="filters" :currClass="currClass" />
    </v-card>
  </div>
</template>

<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import DiligenceClassFilter from './components/DiligenceClassFilter.vue'
import DiligenceClassReportTable from './components/DiligenceClassReportTable.vue'

export default {
  components: {
    DiligenceClassReportTable,
    DiligenceClassFilter,
    StudentBlankView,
  },
  data() {
    return {
      action: {
        state: 'select',
      },
      filters: null,
      currClass: null,
    }
  },
  methods: {
    refresh(query, currClass) {
      this.action.state = 'filtered'
      this.filters = query
      this.currClass = currClass
      console.log(query)
      this.$nextTick(() => {
        this.$refs['diligence-data-table'].searchStudentDiligences()
      })
    },
  },
}
</script>
